import Vue from 'vue'
import App from './App'
import LandingControl from "./Landing_SkillSelect";
// import LandingTest from "./Landing_Search";
import router from "./modules/router";
import impressions from "./modules/impressions";
import cache from './modules/cache'
import weather from './modules/weather'
import recipes from './modules/recipes'
import news from './modules/news'
import install from './modules/install'
import push from './modules/push'
import './registerServiceWorker'
import './styles/main.sass'

Vue.config.productionTip = false
Vue.use(impressions)
Vue.$impressions.init();


Vue.use(router)
Vue.use(cache)
Vue.use(weather)
Vue.use(recipes)
Vue.use(news)
Vue.use(install, { router })
Vue.use(push)

new Vue({
  router,
  render: h => h(window.matchMedia('(display-mode: standalone)').matches || Vue.$install.CheckInstall() ? App : LandingControl)
  // render: h => h(LandingControl)
}).$mount('#app');